import axios from 'axios'
const { VUE_APP_PRINTIT_URL, VUE_APP_TEST_ERROR, VUE_APP_API_URL, VUE_APP_VT_API_URL } = process.env

const getPrinterFriendly = async (payload) => {
  const result = { error: false }
  try {
    const url = VUE_APP_TEST_ERROR || `${VUE_APP_PRINTIT_URL}/printit/api/viewtrail/print`

    const res = await axios
      .post(url, payload, { responseType: 'blob' })

    if (res && res.data) {
      result.data = res.data
      return result
    }
  } catch (err) {
    result.error = true
    return result
  }
}
const getPrinterFriendlyInvoice = async (payload) => {
  const result = { error: false }
  try {
    const url = VUE_APP_TEST_ERROR || `${VUE_APP_PRINTIT_URL}/printit/api/vt-invoice`

    const res = await axios
      .post(url, payload, { responseType: 'blob' })

    if (res && res.data) {
      result.data = res.data
      return result
    }
  } catch (err) {
    result.error = true
    return result
  }
}

const getPrinterFriendlyTHItinerary = async (payload) => {
  const result = { error: false }
  try {
    const url = VUE_APP_TEST_ERROR || `${VUE_APP_VT_API_URL}/vt-api/viewtrail/pdf/TH-Itinerary`

    const res = await axios
      .post(url, payload, { responseType: 'blob' })

    if (res && res.data) {
      result.data = res.data
      return result
    }
  } catch (err) {
    result.error = true
    return result
  }
}

const getPaymentHistory = async (payload, token) => {
  const result = { error: false }
  try {
    const url = VUE_APP_TEST_ERROR || `${VUE_APP_API_URL}/api/superfacts/payments`

    const res = await axios
      .post(url, payload, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
    if (res && res.data) {
      result.data = res.data
      return result
    }
  } catch (err) {
    result.error = true
    return result
  }
}

export {
  getPrinterFriendly,
  getPaymentHistory,
  getPrinterFriendlyTHItinerary,
  getPrinterFriendlyInvoice
}